// src/language/reportLanguage.js
const reportLanguage = {
  en: {
    pageTitle: 'Manage Bills',

    // NEW: top tabs text
    tabReport: 'Send Bill',
    tabBill: 'Manage Bills',

    // Month names
    months: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ],

    // Filters
    searchCustomerPlaceholder: 'Search Customer...',
    month: 'Month',
    quarter: 'Quarter',
    year: 'Year',
    fromDate: 'From Date',
    toDate: 'To Date',

    // Card labels
    currentBill: 'Current Bill',
    pending: 'Pending',
    sendReport: 'Send',
    customDate: 'Custom',

    // Popup
    currentMonth: 'Current Month',
    previousMonth: 'Previous Month',
    twoMonthsAgo: '2 Months Ago',
    date: 'Date',
    liter: 'Liter',
    milkType: 'Milk Type',
    rate: 'Rate',
    action: 'Action',
    cow: 'Cow',
    buffalo: 'Buffalo',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    entries: 'entries',
    noEntries: 'No entries found for this month',
    saving: 'Saving...',
    totalLiters: 'Total Liters',
    totalAmount: 'Total Amount',
  },
  mr: {
    pageTitle: 'बिल मॅनेजमेंट',

    // NEW: top tabs text
    tabReport: 'बिल पाठवा',
    tabBill: 'बिल मॅनेजमेंट',

    // Month names
    months: [
      'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून',
      'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
    ],

    searchCustomerPlaceholder: 'ग्राहक शोधा...',
    month: 'महिना',
    quarter: 'तिमाही',
    year: 'वर्ष',
    fromDate: 'तारीख पासून',
    toDate: 'तारीख पर्यंत',

    currentBill: 'चालू बिल',
    pending: 'बाकी',
    sendReport: 'रिपोर्ट पाठवा',
    customDate: 'हवी ती तारीख',

    // Popup
    currentMonth: 'चालू महिना',
    previousMonth: 'मागील महिना',
    twoMonthsAgo: '2 महिने आधी',
    date: 'तारीख',
    liter: 'लिटर',
    milkType: 'दुधाचा प्रकार',
    rate: 'दर',
    action: 'कृती',
    cow: 'गाय',
    buffalo: 'म्हैस',
    edit: 'संपादित करा',
    save: 'सेव्ह करा',
    cancel: 'रद्द करा',
    close: 'बंद करा',
    entries: 'नोंदी',
    noEntries: 'या महिन्यासाठी कोणत्याही नोंदी आढळल्या नाहीत',
    saving: 'जतन करत आहे...',
    totalLiters: 'एकूण लिटर',
    totalAmount: 'एकूण रक्कम',
  },
};

export default reportLanguage;
